import React from 'react';
import { Heading, Box } from '@chakra-ui/react';
import patternPurple from '@assets/pattern-purple.svg';
import Slideshow from '@components/molecules/Slideshow';
import { SwiperSlide } from 'swiper/react';
import Wrapper from '@components/atoms/Wrapper';
import RelatedBlogCard from '@components/molecules/RelatedBlogCard';

const RelatedBlogs = ({ data }) => {
  const { title, articles } = data;
  return (
    <Box
      bgImage={patternPurple}
      bgRepeat="repeat"
      py="5rem"
      overflow="hidden"
      className="related-blogs-wrapper">
      <Wrapper narrow>
        <Heading
          as="h2"
          fontSize="4xl"
          color="purple.600"
          fontWeight="900"
          pb="1.5rem"
          mt={{ base: `0`, md: `16` }}
          textTransform="uppercase">
          {title}
        </Heading>
        <Slideshow
          className="related-blogs"
          slidesPerView="auto"
          slidesPerViewDesktop="3">
          {articles.map((item) => (
            <SwiperSlide key={item.id}>
              <RelatedBlogCard {...item} />
            </SwiperSlide>
          ))}
        </Slideshow>
      </Wrapper>
    </Box>
  );
};

export default RelatedBlogs;
